import { SectionShell } from "@/components/design-system/SectionShell";
import { Pagination } from "@/components/ui/pagination";

const code = `import { Pagination } from "@/components/ui/pagination";

<Pagination
  page={2}
  pages={3}
  total={42}
  perPage={15}
  hrefFor={(page) => \`/admin/users?page=\${page}\`}
/>`;

export function PaginationSection() {
  return (
    <SectionShell
      id="pagination"
      title="Pagination"
      description={
        <>
          Previous / Next links with a "Showing 16–30 of 42" summary. The
          server decides the page; <code>hrefFor</code> builds each link so
          filters and search terms are kept in the URL.
        </>
      }
      whenToUse={
        <ul>
          <li>Lists that can grow past a screenful (users, feedback).</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Short, bounded lists — just show everything.</li>
          <li>Anything that reads as a feed — consider loading more instead.</li>
        </ul>
      }
      preview={
        <div className="space-y-6">
          <Pagination page={2} pages={3} total={42} perPage={15} hrefFor={(page) => `#page-${page}`} />
          <Pagination page={1} pages={1} total={7} perPage={15} hrefFor={(page) => `#page-${page}`} />
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>The first page disables Previous and the last page disables Next.</li>
          <li>Renders nothing when <code>total</code> is 0 — show an empty state instead.</li>
          <li>Links use Inertia, so navigation keeps the page's shell and scroll.</li>
        </ul>
      }
    />
  );
}
